"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const customStyles = {
    select: {
        position: "relative",
        zIndex: 20,
        minWidth: "150px",
        height: "auto",
        minHeight: "32px",
        borderRadius: "6px",
        borderColor: "#D9D9D9",
        borderWidth: "1px",
        borderStyle: "solid",
        backgroundColor: "#FBFBFD",
        boxShadow: "none",
        padding: "2px 8px",
        color: "#3F3F46",
        fontSize: "14px",
        fontWeight: 700,
        appearance: "none",
        WebkitAppearance: "none",
        MozAppearance: "none",
    },
    option: {
        backgroundColor: "white",
        color: "#3F3F46",
        fontSize: "14px",
        fontFamily: "Noto Sans JP",
        padding: "8px 12px",
        cursor: "pointer",
    },
    wrapper: {
        position: "relative",
        zIndex: 20,
        display: "inline-block",
    },
    arrow: {
        position: "absolute",
        top: "50%",
        right: "10px",
        width: "0",
        height: "0",
        pointerEvents: "none",
        borderLeft: "5px solid transparent",
        borderRight: "5px solid transparent",
        borderTop: "5px solid #3F3F46",
        transform: "translateY(-50%)",
    },
};
const Select = (_a) => {
    var { value, onChange, options, style } = _a, props = __rest(_a, ["value", "onChange", "options", "style"]);
    return (react_1.default.createElement("div", { style: customStyles.wrapper },
        react_1.default.createElement(react_bootstrap_1.Form.Select, Object.assign({ value: value, onChange: onChange, style: Object.assign(Object.assign({}, customStyles.select), style) }, props), options.map((option) => (react_1.default.createElement("option", { key: option.value, value: option.value, style: customStyles.option }, option.label)))),
        react_1.default.createElement("div", { style: customStyles.arrow })));
};
exports.default = Select;
